import { lazy } from "react";

export const customeRoutes = {
  // Will provide valid name for the component in future.
  DashBoard: lazy(() => import("../pages/dashboard/Dashboard")),
  Ballots: lazy(() => import("../pages/ballots/containers/Ballots.Container")),
  BallotDetails: lazy(() => import("../pages/ballots/containers/BallotDetails.Container")),
  WorkItem: lazy(()=> import("../pages/WorkItems/WorkItem")),
  WorkItemAudigLog: lazy(()=> import("../pages/WorkItems/Auditlog")),
  WorkItemDetail: lazy(()=> import("../pages/WorkItemDetails")),
  Invalid : lazy(()=>import("../../src/shared-components/invalid-url/InvalidUrl")),
  NegativeCommentsReview: lazy(() => import("../pages/NegativeCommentsReview/NegativeCommentsReview")),
  NegativeCommentsRulingRationale: lazy(() => import("../pages/NegativeCommentsReview/NegativeCommentsRulingRationale")),
  // Below mentioned code will be removed in future
  Ballot: lazy(() => import("../pages/Ballot/Ballot")),
  BallotDetailsAddItems: lazy(() => import("../pages/BallotDetailsAddItems/BallotDetailsAddItems")),
  ManageAnsiCommittee: lazy(() => import("../pages/Ansi/ManageAnsi/index")),
  ManageBSR108 : lazy(() => import("../pages/Ansi/BSR108/index")),
  ManageBSR109 : lazy(() => import("../pages/Ansi/BSR109/index")),
  AnsiAuditLog: lazy(() => import("../pages/Ansi/AnsiAuditLog/index")),
  PINSReports: lazy(() => import("../pages/Ansi/PINSReports/index"))
};
